const baseRoutes = [
  {
    path: "/salesRatio",
    name: "salesRatio",
    component: () => import("@/views/base/salesRatio.vue"),
    meta: {
      title: "销售比例",
      // keepAlive:true
    },
  },
  {
    path: "/pickupRate",
    name: "pickupRate",
    component: () => import("@/views/base/pickupRate.vue"),
    meta: {
      title: "取件率",
      keepAlive: true,
    },
  },
  {
    path: "/carousel",
    name: "carousel",
    component: () => import("@/views/base/carousel.vue"),
    meta: {
      title: "轮播图列表",
      keepAlive: true,
    },
  },
  {
    path: "/carouselAdd",
    name: "carouselAdd",
    component: () => import("@/views/base/carouselAdd.vue"),
    meta: {
      title: "轮播图添加",
    },
  },
  {
    path: "/publicSetting",
    name: "publicSetting",
    component: () => import("@/views/base/publicSetting.vue"),
    meta: {
      title: "公共配置",
    },
  },
  {
    path: "/publicSettingAdd",
    name: "publicSettingAdd",
    component: () => import("@/views/base/publicSettingAdd.vue"),
    meta: {
      title: "公共配置添加",
    },
  },
  {
    path: "/noticeSetting",
    name: "noticeSetting",
    component: () => import("@/views/base/noticeSetting.vue"),
    meta: {
      title: "公告配置",
    },
  },
  {
    path: "/expressSetting",
    name: "expressSetting",
    component: () => import("@/views/base/expressSetting.vue"),
    meta: {
      title: "快递配置",
    },
  },
  {
    path: "/blindDateKF",
    name: "blindDateKF",
    component: () => import("@/views/base/blindDateKF.vue"),
    meta: {
      title: "相亲客服",
    },
  },
  {
    path: "/blindDateKFAdd",
    name: "blindDateKFAdd",
    component: () => import("@/views/base/blindDateKFAdd.vue"),
    meta: {
      title: "相亲客服添加",
    },
  },
];

export default baseRoutes;
